__webpack_require__.p = "/page-miniblog/";